import { baseHttp } from './trpc.js';
import type { Filtro } from '../estado/filtros.js';

export type Relatorio = 'documentos' | 'itens' | 'obras' | 'divergencias';

/**
 * A API responde com Content-Disposition, então basta um <a href download>:
 * o navegador cuida do arquivo e o cookie de sessão vai junto na navegação.
 */
export function urlExportacao(relatorio: Relatorio, filtro: Filtro, extra?: { cno?: string }): string {
  const q = new URLSearchParams();
  const busca = filtro.busca.trim();
  if (busca !== '') q.set('busca', busca);
  for (const tipo of filtro.tipos) q.append('tipos', tipo);
  if (filtro.competencia) q.set('competencia', filtro.competencia);
  const cno = extra?.cno ?? filtro.cno;
  if (cno) q.set('cno', cno);
  if (filtro.somenteComCno) q.set('somenteComCno', 'true');

  const qs = q.toString();
  return `${baseHttp}/api/export/${relatorio}.csv${qs ? `?${qs}` : ''}`;
}

export function nomeArquivo(relatorio: Relatorio): string {
  const nomes: Record<Relatorio, string> = {
    documentos: 'documentos-fiscais.csv',
    itens: 'itens-fiscais.csv',
    obras: 'obras-cno.csv',
    divergencias: 'divergencias.csv',
  };
  return nomes[relatorio];
}
